import './App.css';
import {AppBar, Box, Button, Container, Toolbar, Tooltip} from "@mui/material";
import {LanguageContext} from "./context/LanguageContext";
import {useContext} from "react";
import {languageOptions} from "./languages";
import {useTheme} from "@emotion/react";
import {Language} from "@mui/icons-material";
import logo from "./assets/images/one_solutions.svg";
import Footer from "./components/Footer";
import Rating from "./components/Rating";

function App() {
    const languageContext = useContext(LanguageContext);
    const theme = useTheme();

    const handleLanguageChange = event => {
        let selectedLanguage;
        const lang = languageContext.language.id;
        if (lang === "hu") {
            selectedLanguage = languageOptions.find(item => item.id === "en");
        } else {
            selectedLanguage = languageOptions.find(item => item.id === "hu");
        }
        languageContext.setLanguage(selectedLanguage);
    };

    return (
        <Box className="App">
            <Box sx={{flexGrow: 1}}>
                <AppBar position="static">
                    <Toolbar sx={{backgroundColor: "white", justifyContent: "space-between"}}>
                        <img src={logo} alt="invitech" style={{maxHeight: theme.spacing(5)}}/>
                        <Tooltip title={languageContext.dictionary.changeLanguage}>
                            <Button
                                color="primary"
                                onClick={handleLanguageChange}
                                size="small"
                                sx={{margin: 0.5}}
                            >
                                <Language sx={{marginRight: 0.5}}/>
                                {languageContext.language.id}
                            </Button>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
            </Box>
            <Container maxWidth="md" sx={{paddingTop: 6, paddingBottom: 12}}>
                <Rating/>
            </Container>
            <Footer sx={{paddingTop: 12}}/>
        </Box>
    );
}

export default App;
